var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72163 2.81248C10.7464 1.07976 13.2536 1.07976 14.2784 2.81248L23.4032 18.2408C24.4469 20.0054 23.1749 22.2354 21.1248 22.2354H2.87522C0.825143 22.2354 -0.446802 20.0054 0.596815 18.2408L9.72163 2.81248ZM13.3671 3.35148C12.7522 2.31185 11.2479 2.31186 10.633 3.35149L1.50818 18.7798C0.882006 19.8386 1.64517 21.1766 2.87522 21.1766H21.1248C22.3549 21.1766 23.1181 19.8386 22.4919 18.7798L13.3671 3.35148Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 7.23535C12.2925 7.23535 12.5295 7.47238 12.5295 7.76476V14.8236C12.5295 15.116 12.2925 15.353 12.0001 15.353C11.7077 15.353 11.4707 15.116 11.4707 14.8236V7.76476C11.4707 7.47238 11.7077 7.23535 12.0001 7.23535Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7057 17.647C12.7057 18.0369 12.3897 18.3529 11.9998 18.3529C11.61 18.3529 11.2939 18.0369 11.2939 17.647C11.2939 17.2572 11.61 16.9412 11.9998 16.9412C12.3897 16.9412 12.7057 17.2572 12.7057 17.647Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 18.3529C12.3897 18.3529 12.7057 18.0369 12.7057 17.647C12.7057 17.2572 12.3897 16.9412 11.9998 16.9412C11.61 16.9412 11.2939 17.2572 11.2939 17.647C11.2939 18.0369 11.61 18.3529 11.9998 18.3529Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.f374406aac287f086f917a3d477fb036.svg";
export { ForwardRef as ReactComponent };